const __WEBPACK_NAMESPACE_OBJECT__ = require("@auth0/auth0-react");